import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c9e1cfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Confirmar No. Embarque", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  class: "row g-3 needs-validation",
  novalidate: ""
}
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom01",
  class: "form-label"
}, "Fecha", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "operador", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "numero_vuelo", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "No. Embarque", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_18 = { class: "col-sm-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Confirmado Por", -1))
const _hoisted_20 = { class: "col-sm-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Fecha Confirmado", -1))
const _hoisted_22 = { class: "col-sm-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Hora Confirmado", -1))

import { Ref, ref } from 'vue'
import axios from 'axios'
import { UrlGlobal } from '@/store/dominioGlobal';
import { userGlobalStore } from '@/store/userGlobal';
import { useDateTimeStore } from '@/store/dateTimeStore';
 

export default /*#__PURE__*/_defineComponent({
  __name: 'UpConfirma',
  props: {
    btnUp: Boolean,
    fecha: String,
    operador: String,
    numero_vuelo: String,
    nom_operador: String,
    no_embarque: String,
    confirmado: String,
    fecha_confirma: String,
    hora_confirma: String,

},
  emits: ['updateProps'],
  setup(__props, { emit: __emit }) {

const dateTimeStore = useDateTimeStore();
const userStore = userGlobalStore();

const dUrl = UrlGlobal()

//props y emits ----------------------------------------------------------------
const props = __props
const emits = __emit
const handleClick = () => {
    emits("updateProps", !props.btnUp)
}
//------------------------------------------------------------------------------

//variables reactivas para el formulario----------------------------------------
let fecha = ref(props.fecha)
let operador = ref(props.operador)
let numero_vuelo = ref(props.numero_vuelo)
let no_embarque = ref(props.no_embarque)
let confirmado = userStore.globalUser
let fecha_confirma = dateTimeStore.formattedDate
let hora_confirma = dateTimeStore.formattedTime
//------------------------------------------------------------------------------

const handleSubmit = async () => {
    try {
        console.log(no_embarque.value)
        const response = await axios.post(dUrl.urlGlobal +'/api2/update/', {
            table: 'cardmani', 
            filters: { fecha: fecha.value, operador: operador.value, numero_vuelo: numero_vuelo.value,
                    no_embarque: no_embarque.value }, // Filtro para identificar el registro a actualizar
            data: { confirmado: confirmado, fecha_confirma: fecha_confirma, hora_confirma: hora_confirma,
                status:'L', modificado_por: confirmado, fecha_status: dateTimeStore.formattedDate,
                hora_status: dateTimeStore.formattedTime } // Datos a actualizar
        })
        console.log(response.data)
        emits("updateProps", !props.btnUp)
    } catch (error) {
        console.error("Error actualizando datos:", error)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom01",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fecha) ? (fecha).value = $event : fecha = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(fecha)]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(operador) ? (operador).value = $event : operador = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(operador)]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(numero_vuelo) ? (numero_vuelo).value = $event : numero_vuelo = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(numero_vuelo)]
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(no_embarque) ? (no_embarque).value = $event : no_embarque = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(no_embarque)]
          ]),
          _hoisted_17
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("input", {
            class: "form-control form-control-sm",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(confirmado) ? (confirmado).value = $event : confirmado = $event)),
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(confirmado)]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _withDirectives(_createElementVNode("input", {
            class: "form-control form-control-sm",
            type: "date",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(fecha_confirma) ? (fecha_confirma).value = $event : fecha_confirma = $event))
          }, null, 512), [
            [_vModelText, _unref(fecha_confirma)]
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createElementVNode("input", {
            class: "form-control form-control-sm",
            type: "time",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(hora_confirma) ? (hora_confirma).value = $event : hora_confirma = $event))
          }, null, 512), [
            [_vModelText, _unref(hora_confirma)]
          ])
        ]),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-2",
            type: "button",
            style: {"background-color":"#24292F"},
            onClick: handleClick
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            style: {"background-color":"#001982"},
            onClick: handleSubmit
          }, "Enviar")
        ])
      ])
    ])
  ], 64))
}
}

})